<template>
  <a-modal
    title="Aprobar reconocimiento"
    :visible="visible"
    :confirm-loading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
    width="80%"
  >
    <a-form-model :model="iForm" v-bind="fiOptions" :rules="formRules"
                  ref="form">
      <a-row :gutter="[16,16]">
        <p align="justify" v-html="message[role]"/>
        <a-col v-bind="colSpan">
          <a-form-model-item v-bind="fiOptions" :label="$t('Calificación')" prop="qualification">
            <a-radio-group v-model="iForm.qualification">
              <a-radio  :value="true">
                APRUEBA
              </a-radio>
              <a-radio :value="false">
                RECHAZA
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col v-bind="colSpan">
          <a-form-model-item v-bind="fiOptions" :label="$t('Observaciones')" prop="obs" has-feedback>
            <a-textarea style="width: 100%"
                        v-model="iForm.obs"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
      this.initFormRules()
      this.message = this.$getConfigValue('APR_MESSAGE', {
        'APR_HSEQ': 'EL COLABORADOR NO PRESENTA REPORTES DE ACCIDENTES O INCIDENTES EN LOS ÚLTIMOS 2 AÑOS, REPORTES POR EL NO USO DE ELEMENTOS DE PROTECCIÓN PERSONAL O DE ACTOS Y CONDICIONES INSEGURAS.',
        'APR_BIENESTAR': 'EL COLABORADOR NO CUENTA CON PROCESOS ABIERTOS EN EL ESPACIO DE ESCUCHA CON REFERENCIA A CONFLICTOS EN LA DIMENSIÓN LABORAL O CASOS INFERIORES A 2 AÑOS EN EL COMITÉ DE CONVIVENCIA.',
        'APR_OPERACIONES': 'EL COLABORADOR NO PRESENTA REPORTES NEGATIVOS EN LA HOJA DE VIDA.'
      })
      if (typeof this.message === 'string') {
        this.message = JSON.parse(this.message)
      }
    },
    data () {
      return {
        iForm: {},
        message: {},
        formRules: {},
        colSpan: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 3},
          'wrapper-col': {span: 21},
          'has-feedback': true
        },
        visible: false,
        loading: false,
        record: {},
        role: null
      }
    },
    methods: {
      initFormRules () {
        this.formRules = {
          qualification: [{required: true, message: 'Valor requerido'}],
          obs: [{required: true, message: 'Valor requerido'}]
        }
      },
      showModal ({record, role}) {
        this.visible = true
        this.record = record
        this.role = role
      },
      handleOk (e) {
        if (this.loading) return
        this.$refs.form.validate(valid => {
          if (valid) {
            this.loading = true
            let req = {
              id_emp: this.record.id_emp,
              obs: this.iForm.obs,
              qualification: this.iForm.qualification,
              qualified_rol: this.role,
              message: this.message[this.role],
              empleado: this.record.id_emp_name
            }
            this.httpClient.getInstance().post('recognition_year', req)
              .then(() => {
                this.$emit('handleOk')
                Mensajes.success('Correcto', 'Datos guardados correctamente')
              })
              .catch((error) => {
                Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible guardar la información, contacte al administrador.'))
              })
              .then(() => {
                this.loading = false
                this.visible = false
                this.iForm = {}
              })
          }
        })
      },
      handleCancel (e) {
        this.visible = false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/Reconocimiento/ModalCalificacionReconocimientoAnual.vue